/**
 * Maps a raw backend confidence-issue field name (InvoiceImportIssueDto.field, PascalCase
 * nameof(ImportedInvoiceDataDto property) as set by InvoiceImportValidationPolicy) to the
 * corresponding React Hook Form field name in ApproveImportModal's CorrectionFormData.
 *
 * Not a trivial camelCase transform: SupplierName/SupplierTaxId are the OCR-native backend
 * field names (see PdfOcrImporter._azureFieldConfidenceKeyMap), but the correction form and
 * UserInvoiceCorrections use SellerName/SellerNip.
 */
const OCR_FIELD_TO_FORM_FIELD: Record<string, string> = {
  InvoiceNumber: 'invoiceNumber',
  IssueDate: 'issueDate',
  SupplierName: 'sellerName',
  SupplierTaxId: 'sellerNip',
  TotalGross: 'totalGross',
};

/**
 * Resolves a backend confidence-issue field name to a correction form field name.
 *
 * @param field - Raw InvoiceImportIssueDto.field value, or null
 * @returns Matching form field name, or null when there is no direct form-field mapping
 */
export function mapOcrFieldToFormField(field: string | null): string | null {
  if (!field) {
    return null;
  }

  return OCR_FIELD_TO_FORM_FIELD[field] ?? null;
}
